import { render, staticRenderFns } from "./LemanYeidey.vue?vue&type=template&id=51e2d562&"
import script from "./LemanYeidey.vue?vue&type=script&lang=js&"
export * from "./LemanYeidey.vue?vue&type=script&lang=js&"
import style0 from "./LemanYeidey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports